import CryptoJS from "crypto-js";

export function CreateIntercomHash(userId: number) {
  const secret = process.env.VUE_APP_PeakIntercomSecret || "";
  const message = userId.toString();
  const hash = CryptoJS.HmacSHA256(message, secret);
  return hash.toString(CryptoJS.enc.Hex);
}
